import {z} from 'zod'

export const DesignatedSectionSchema = z.object({
  networkTrackId: z.string(),
  kmStart: z.number(),
  kmEnd: z.number(),
})

export const DesignableZoneSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  protectionTypeId: z.string().nullable(),
  groupIds: z.array(z.string()),
  sections: z.array(DesignatedSectionSchema),
})

export const DesignableGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  zoneIds: z.array(z.string()),
  sections: z.array(DesignatedSectionSchema),
})

export const WholeTrackSchema = z.object({
  networkTrackId: z.string(),
  sections: z.array(DesignatedSectionSchema),
})

export const DesignablesSchema = z.object({
  zones: z.array(DesignableZoneSchema),
  groups: z.array(DesignableGroupSchema),
  wholeTracks: z.array(WholeTrackSchema),
})
